module.exports = __webpack_public_path__ + "img/stackslash-inspect-small.65a3c671.jpg";